import type { PortalPrimitives } from '../types';
import {
  black,
  blue,
  green,
  hero,
  neutral,
  red,
  white,
  yellow,
} from './primitives-v4';

export { black, blue, green, hero, neutral, red, white, yellow };

export const primitives: PortalPrimitives = {
  neutral,
  hero,
  blue,
  yellow,
  red,
  green,
  black,
  white,
};
